<template>
  <div
    style="overflow-x: hidden; text-align: center; margin: 0px 20px 0px 10px; border-left: 1px solid lightgrey; border-right: 1px solid lightgrey; font: 12px 'Microsoft YaHei'; color: #333">
    <statistics-radio-group v-model="$store.state.work.statisticsFilterType">
      <div style="width: 610px; display: flex;">
        <div style="display: flex; align-items: center;">
          <div style="margin-left: 10px; margin-right: 4px">
            <statistics-radio :label="filterType.ON_SITE_CARS">
              <div style="font-weight: bold; font-size: 17px; margin-top: -2px">{{statistics.onSite}}</div>
              <div style="margin-top: -2px; width: 70px">在厂车辆</div>
            </statistics-radio>
          </div>
          <div>
            <statistics-radio :label="filterType.RUN_CARS" style="display: flex;">
              <div style="width: 70px">施工车辆</div>
              <div class="number">{{statistics.running}}</div>
            </statistics-radio>
            <statistics-radio :label="filterType.WAIT_CARS" style="display: flex; margin-top: 1px;">
              <div style="width: 70px">待修车辆</div>
              <div class="number">{{statistics.waiting}}</div>
            </statistics-radio>
          </div>
        </div>
        <div
          style="margin-left: 6px; border-left: 1px solid lightgrey; display: flex; flex-direction: column; padding: 0 6px;">
          <div style="display: flex">
            <statistics-radio :label="filterType.OVERDUE_CARS" style="display: flex; margin-right: 1px">
              <div style="width: 70px;">交车超时</div>
              <div class="number">{{statistics.overdue}}</div>
            </statistics-radio>
            <statistics-radio :label="filterType.DELAY_CARS" style="display: flex; margin-right: 1px">
              <div style=" width: 70px;">延迟交车</div>
              <div class="number">{{statistics.delay}}</div>
            </statistics-radio>
            <statistics-radio :label="filterType.REWORK_CARS" style="display: flex; margin-right: 1px">
              <div style="width: 70px;">返工车辆</div>
              <div class="number">{{statistics.reworked}}</div>
            </statistics-radio>
            <statistics-radio :label="filterType.INTERRUPT_CARS" style="display: flex">
              <div style="width: 70px;">中断车辆</div>
              <div class="number">{{statistics.interrupted}}</div>
            </statistics-radio>
          </div>
          <div style="border-bottom: 1px solid lightgrey;"></div>
          <div style="display: flex;">
            <statistics-radio :label="filterType.TODAY_CARS" style="display: flex; margin-right: 1px">
              <div style="width: 70px;">今日车辆</div>
              <div class="number">{{statistics.enterToday}}</div>
            </statistics-radio>
            <statistics-radio :label="filterType.DUE_TODAY_CARS" style="display: flex; margin-right: 1px">
              <div style="width: 70px;">今日应交</div>
              <div class="number">{{statistics.dueToday}}</div>
            </statistics-radio>
            <statistics-radio :label="filterType.TODAY_DELIVERY_CARS" style="display: flex; margin-right: 1px">
              <div style="width: 70px;">今日已交</div>
              <div class="number">{{statistics.todayDelivery}}</div>
            </statistics-radio>
            <statistics-radio :label="filterType.DUE_TOMORROW_CARS" style="display: flex">
              <div style="width: 70px;">明日应交</div>
              <div class="number">{{statistics.dueTomorrow}}</div>
            </statistics-radio>
          </div>
        </div>
      </div>
    </statistics-radio-group>
  </div>
</template>

<script>
  import StatisticsRadio from '@/views/kanban/statistics/StatisticsRadio'
  import StatisticsRadioGroup from '@/views/kanban/statistics/StatisticsRadioGroup'
  import filterType from '@/utils/workStatusFilter'
  import { statisticsDataMixin } from '@/views/mixins/StatisticsData'

  export default {
    name: 'StatisticsKanban',
    mixins: [statisticsDataMixin],
    components: {
      StatisticsRadioGroup,
      StatisticsRadio
    },
    data () {
      return {
        filterType
      }
    }
  }
</script>

<style scoped>
  .number {
    text-align: left;
    width: 30px;
    font-weight: bold;
  }
</style>
